import type {
  FC,
  ReactNode,
} from "react"
import { useEffect } from "react"

import styles from "src/styles/themeClasses.module.scss"

interface Props {
  children: ReactNode;
}

// this component applies the default theme to the body element
export function DefaultThemeComponent(props: Props) {
  useEffect(
    () => {
      const className = styles.sugarmate

      document.body.classList.add(className)

      return () => {
        document.body.classList.remove(className)
      }
    },
    [],
  )

  return (
    <>
      {props.children}
    </>
  )
}

export function getDefaultThemeWrappedComponent(Component: FC<object>) {
  const WrappedComponent = () => (
    <DefaultThemeComponent>
      <Component />
    </DefaultThemeComponent>
  )

  WrappedComponent.displayName = "DefaultThemeWrappedComponent"
  return WrappedComponent
}
